package com.fireavert.properties.delete_property_dialog

data class DeletePropertyDialogViewState(val isOpen: Boolean = false, val isDeleting: Boolean = false)
